import TextWidget from 'volto-form-block/components/Widget/TextWidget';
import SelectWidget from 'volto-form-block/components/Widget/SelectWidget';
import withVocabulary from './withVocabulary';
import { FormattedMessage } from 'react-intl';

export const additionalFields = [
  {
    id: 'phone',
    label: <FormattedMessage id="Phone" defaultMessage="Phone" />,
    field_type: 'text',
    component: TextWidget,
    isValid: (val, name) => {
      const phoneRegex = /^\+[1-9]\d{1,14}$/;
      const isValid = phoneRegex.test(val[name].value);
      return isValid;
    },
  },
  {
    id: 'country',
    label: <FormattedMessage id="Country" defaultMessage="Country" />,
    component: withVocabulary('fbc.addon.CountryVocabulary')(SelectWidget),
  },
];
